import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Brand } from "@/components/Brand";
import { Loader2 } from "lucide-react";

/** iepplataforma.com/video/assinatura -> vídeo do passo a passo (o link é trocado em Configurações → Escola). */
export default function VideoRedirect() {
  const [msg, setMsg] = useState("");
  useEffect(() => {
    api.get("/public/contract-video")
      .then((r) => (r.data.url ? window.location.replace(r.data.url) : setMsg("O vídeo ainda não está disponível. Fale com a equipe IEP.")))
      .catch(() => setMsg("Não foi possível abrir o vídeo agora. Tente de novo em instantes."));
  }, []);
  return (
    <div className="min-h-screen grid place-items-center bg-[#F8FAFC] px-4">
      <div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-8 max-w-md w-full text-center">
        <div className="flex justify-center mb-6"><Brand size="md" /></div>
        {msg ? <p className="text-slate-700">{msg}</p> : <><Loader2 className="h-8 w-8 animate-spin text-[#232D4F] mx-auto" /><p className="text-slate-500 mt-3">Abrindo o vídeo…</p></>}
      </div>
    </div>
  );
}
